<div class="page">
    <div>System Admin</div> 
    <div class="row">
        <div class="col-12"> 
            <div class="tab-sec">
                <div class="tab-block">
                    <div class="tab" tabindex="0">
                        <a class="tab-link" routerLinkActive="active"  [routerLink]="'manage-publish-dist'">
                            Manage Publish/Distribution
                        </a>
                    </div>
                    <div class="tab border-right" tabindex="0">
                        <a class="tab-link" routerLinkActive="active"  [routerLink]="'manage-projects'">
                            Manage Projects
                        </a>
                    </div>
                </div>  
            </div>
            <div class="content">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
